import { processPosthogMethod } from "../../../shared/lib/posthog";
import { createUserStore } from "../../../shared/store/user";
import type { UserWithPermissions } from "../schemas/user";
import { trpc } from "../trpc/client";

export const useAuth = createUserStore<UserWithPermissions>({
	authHostname: import.meta.env.VITE_AUTH_HOSTNAME,
	async getUser() {
		const user = await trpc.auth.getUser.query();
		processPosthogMethod("identify", [
			user.id.toString(),
			{
				email: user.email,
				institutionId: user.institutionId,
			},
		]);

		return user;
	},
});
